import React, { useState } from 'react';

import { Collapse } from '@material-ui/core';

import SubsectionInFrame from '../../misc/SubsectionInFrame';
import { FormattedMessageWrappedInSpan } from '../../misc';
import SecondFactorGuardInfoCarousel from './SecondFactorGuardInfoCarousel';
import GDPRHint from '../GDPRHint';

export const SecondFactorDetailsInfo = () => {
  const [showDetailedProcedure, setShowDetailedProcedure] = useState(false);

  return (
    <SubsectionInFrame
      title={
        <FormattedMessageWrappedInSpan
          id="secondFactorDetailsInfo.title"
          defaultMessage="Your privacy matters"
          className="typography uppercase typography-title_small"
        />
      }
      lastInRow
      topPadding
      color="medium"
      gap={20}
    >
      <FormattedMessageWrappedInSpan
        className="second-factor-guard-details-subtitle"
        id="secondFactorDetailsInfo.subtitle"
        defaultMessage="To protect it, we have a special, <b>encrypted authentication procedure</b>, similar to storing passwords."
        values={{
          b: (chunks) => <b>{chunks}</b>,
        }}
      />
      <div
        className={`second-factor-carousel carousel-invisible-${showDetailedProcedure}`}
      >
        <Collapse in={showDetailedProcedure} timeout="auto">
          <SecondFactorGuardInfoCarousel shouldRunAutoplay={showDetailedProcedure} />
        </Collapse>
      </div>
      <button
        className="btn full-width btn-default secondary-new secondary-new-in-subsection"
        onClick={() => setShowDetailedProcedure((prevState) => !prevState)}
      >
        {showDetailedProcedure ? (
          <FormattedMessageWrappedInSpan
            id="secondFactorDetailsInfo.hideDetails"
            defaultMessage="Close details"
            className="typography bold-text typography-title_xsmall"
          />
        ) : (
          <FormattedMessageWrappedInSpan
            id="secondFactorDetailsInfo.expandDetails"
            defaultMessage="See how it works"
            className="typography bold-text typography-title_xsmall"
          />
        )}
      </button>
      <GDPRHint secondFactorNote={true} />
    </SubsectionInFrame>
  );
};
